import type { ApiResponse, UserDto, RegisterInput, LoginInput } from '@lyricshub/shared';
import { api } from './api';

export interface AuthTokenResponse {
  user: UserDto;
  accessToken: string;
}

export const authService = {
  async register(data: RegisterInput): Promise<ApiResponse<AuthTokenResponse>> {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  async login(data: LoginInput): Promise<ApiResponse<AuthTokenResponse>> {
    const response = await api.post('/auth/login', data);
    return response.data;
  },

  async logout(): Promise<ApiResponse<void>> {
    const response = await api.post('/auth/logout');
    return response.data;
  },

  async refreshToken(): Promise<ApiResponse<AuthTokenResponse>> {
    const response = await api.post('/auth/refresh');
    return response.data;
  },

  async getMe(): Promise<ApiResponse<UserDto>> {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async verifyEmail(token: string): Promise<ApiResponse<void>> {
    const response = await api.post('/auth/verify-email', { token });
    return response.data;
  },

  async forgotPassword(email: string): Promise<ApiResponse<void>> {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  async resetPassword(token: string, password: string): Promise<ApiResponse<void>> {
    const response = await api.post('/auth/reset-password', { token, password });
    return response.data;
  },
};
